export function teamTopicReducer(state, action) {
  switch (action.type) {
    case "loadTopics":
      return {
        ...state,
        topics: action.topics,
      };

    default:
      throw new Error();
  }
}
